// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"37866b6a","294":"37866b6a","620":"37866b6a","713":"1f37f635","888":"740b17d4","976":"bfee7d76","977":"1b70985f"}[chunkId] + ".chunk.css";
};